package com.mrpowergamerbr.puppydough.webrune

import com.mrpowergamerbr.puppydough.VirtualInputSink
import js.objects.TypedPropertyDescriptor
import js.reflect.Reflect
import web.events.EventType
import web.html.HTMLCanvasElement
import web.html.HTMLIFrameElement
import web.keyboard.*
import web.window.window

/**
 * Dispatches keypresses to an iframe
 *
 * Emscripten copies keyCode/which into the runner, but browsers ignore them in the KeyboardEvent constructor, so we override them with defineProperty
 */
class IframeInputSink(val iframe: HTMLIFrameElement) : VirtualInputSink {
    override fun keyDown(vk: Int) = dispatch(KeyboardEvent.KEY_DOWN, vk)
    override fun keyUp(vk: Int) = dispatch(KeyboardEvent.KEY_UP, vk)

    private fun dispatch(type: EventType<KeyboardEvent>, vk: Int) {
        val (key, code) = when (vk) {
            37 -> "ArrowLeft" to KeyCode.ArrowLeft
            38 -> "ArrowUp" to KeyCode.ArrowUp
            39 -> "ArrowRight" to KeyCode.ArrowRight
            40 -> "ArrowDown" to KeyCode.ArrowDown
            67 -> "c" to KeyCode.KeyC
            88 -> "x" to KeyCode.KeyX
            90 -> "z" to KeyCode.KeyZ
            else -> error("Unsupported virtual key $vk")
        }

        val event = KeyboardEvent(
            type,
            KeyboardEventInit(
                key = key,
                code = code,
                bubbles = true,
                cancelable = true,
            )
        )

        for (property in listOf("keyCode", "which"))
            Reflect.defineProperty(event, property, TypedPropertyDescriptor(get = { vk }))

        // Dispatched on the canvas and bubbling, so it reaches the runner whether it listens on the canvas, document or window
        iframe.contentWindow?.dispatchEvent(event)
    }
}
